/* eslint-disable prefer-rest-params */
export const GetSearch = function (name, ignoreCase) {
  let reg;
  if (ignoreCase) {
    reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  } else {
    reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  }
  const r = window.location.search.substring(1).match(reg);
  if (r) {
    return decodeURIComponent((r[2]));
  }
  return null;
};


export const ValidURL = function (sUrl) {
  return !!((/^(https?:\/\/)?[\w\-.]+\.(qq|tencent)\.com($|\/|\\)/i).test(sUrl) || (/^[\w][\w/.\-_%]+$/i).test(sUrl) || (/^[/\\][^/\\]/i).test(sUrl) || (/^(weixin:\/\/)[\w\-.]+($|\/|\\)/i).test(sUrl));
};

const htmlUtil = {
  /**
     * 获取UTF-8字符的长度，英文算1，中文算3
     * @param str
     * @returns {Number}
     */
  getUTF8StrLength(str) {
    let realLength = 0;
    const len = str.length;
    let charCode = -1;
    for (let i = 0; i < len; i++) {
      charCode = str.charCodeAt(i);
      if (charCode >= 0 && charCode <= 128) {
        realLength += 1;
      } else {
        // 如果是中文则长度加3
        realLength += 3;
      }
    }
    return realLength;
  },
  /**
     * html正文编码：对需要出现在HTML正文里(除了HTML属性外)的不信任输入进行编码
     * @param sStr
     * @returns {string}
     * @constructor
     */
  HtmlEncode(str) {
    let sStr = str;
    sStr = sStr.replace(/&/g, '&amp;');
    sStr = sStr.replace(/>/g, '&gt;');
    sStr = sStr.replace(/</g, '&lt;');
    sStr = sStr.replace(/"/g, '&quot;');
    sStr = sStr.replace(/'/g, '&#39;');
    return sStr;
  },
  /**
     * html正文解码：对HtmlEncode函数的结果进行解码
     * @param sStr
     * @returns {string}
     * @constructor
     */
  HtmlUnEncode(str) {
    let sStr = str;
    sStr = sStr.replace(/&amp;/g, '&');
    sStr = sStr.replace(/&gt;/g, '>');
    sStr = sStr.replace(/&lt;/g, '<');
    sStr = sStr.replace(/&quot;/g, '"');
    sStr = sStr.replace(/&#39;/g, '\'');
    return sStr;
  },
  /**
     * 例子：
     * StringFormat("&Type={0}&Ro={1}&lPlan={2}&Plan={3}&={4}&Id={5}&Id={6}",
     *  data1, data2, data3,data4, data5,data6,data7);
     * @returns {*}
     * @constructor
     */
  StringFormat() {
    if (arguments.length === 0) {
      return null;
    }
    let str = arguments[0];
    for (let i = 1; i < arguments.length; i++) {
      const re = new RegExp(`\\{${i - 1}\\}`, 'gm');
      str = str.replace(re, arguments[i]);
    }
    return str;
  },

  storageSet(key, value) {
    return localStorage.setItem(key, value);
  },

  storageGet(key) {
    return localStorage.getItem(key);
  },


  /**
     * 从URL中查找参数，找不到返回 null
     * @param name
     * @returns {*}
     */
  GetSearch,

  GetProtocal(url) {
    const reg = /^(.*?):\/\//;
    const matches = reg.exec(url);
    if (matches && matches[1]) return matches[1];
    return 'http';
  },

  NewUrl(url) {
    return `${this.GetProtocal(location.href)}://${document.domain}${url}`;
  },

  addUrlParameter(key, value) {
    const func = function (uri, key, value) {
      if (!value) {
        return uri;
      }
      const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
      const separator = uri.indexOf('?') !== -1 ? '&' : '?';
      if (uri.match(re)) {
        return uri.replace(re, `$1${key}=${value}$2`);
      }

      return `${uri + separator + key}=${value}`;
    };

    const newurl = func(window.location.href, key, value);
    window.history.replaceState({
      path: newurl,
    }, '', newurl);
  },

  platform() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      return 'ios';
    }
    if (/(Android)/i.test(navigator.userAgent)) {
      return 'android';
    }

    return 'pc';
  },

  clipboard: {
    write(str = '') {
      const save = function (e) {
        e.clipboardData.setData('text/plain', str);
        e.preventDefault();
      };
      document.addEventListener('copy', save);
      document.execCommand('copy');
      document.removeEventListener('copy', save);
    },
  },
};


export default htmlUtil;

